// extracted by mini-css-extract-plugin
export default {"ImageLinkCard":"ImageLinkCard_ImageLinkCard__uUN9i","title":"ImageLinkCard_title__TX3sh"};